import { Spin, Table } from 'antd';
import { useMemo } from 'react';

import type { ModelProductItem } from '@app/api/Products';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/Products/data';
import type { ProductsTableType } from '@app/pages/Warehouses/Products/types';
import { getRange } from '@app/pages/Warehouses/Products/utils';

const TABLE = `${PF}_table`;

export const ProductsTable: ProductsTableType = ({
  isPageLoading,
  isFetching,
  data,
  pagination: { PageN, ItemsPerPage, Total },
  onPaginate,
  onPageSizeChange,
  columns,
}) => {
  const { isMobile } = useWindowSize();
  const { from, to } = useMemo(
    () => getRange({ ItemsPerPage, Total, PageN }),
    [ItemsPerPage, Total, PageN]
  );

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelProductItem>
          columns={columns}
          dataSource={data}
          rowKey={({ ProductId }) => ProductId}
          pagination={
            Total > 0
              ? {
                  responsive: true,
                  current: PageN,
                  total: Total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  onShowSizeChange: (_, pageSize) => onPageSizeChange(pageSize),
                  showTotal: (total) =>
                    isMobile
                      ? `Всего ${total}`
                      : `Показаны результаты с ${from} по ${to} из ${total}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          loading={isFetching}
          scroll={{ x: 900 }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
